import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { ZuiShellBase } from './zui-shell-base';
import { style } from './zui-shell-content-css.js';

/**
 * Content area that wraps all information for applications.
 *
 * @element zui-shell-content
 *
 * @slot - Default, unnamed slot; for inserting all application content into `<zui-shell-content>`
 */
export class ZuiShellContent extends ZuiShellBase {
  static get styles() {
    const result = [super.styles, style];

    return result;
  }

  constructor() {
    super();
    this._observeNavCollapseChange = true;
    this._observeHasShellNav = true;
    this._observeHasAppBar = true;
    this._observeBannerHeightChange = true;
  }

  connectedCallback() {
    super.connectedCallback();
    this._storeElement(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this._removeElement(this);
  }

  render() {
    return html`
      <main
        role="main"
        class="main ${classMap({
          'nav-collapsed': this._isNavCollapsed,
          'no-nav': !this._hasShellNav,
          'no-appbar': !this._hasAppBar,
        })}"
      >
        <slot></slot>
      </main>
    `;
  }
}

window.customElements.define('zui-shell-content', ZuiShellContent);

declare global {
  interface HTMLElementTagNameMap {
    'zui-shell-content': ZuiShellContent;
  }
}
